import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "../Navigations/MainNavigation";
import RulesNav from "./Nav";
import Footer from "../Footer";

import styled from "styled-components";
const ContainerMain = styled.div`
  width: 100%;
`;
const Container = styled.div`
  width: 80%;
  height: 1800px;
  padding-top: 100px;
  margin-left: 10%;
`;
const Nav = styled.div`
  width: 20%;
  height: 100%;
  float: left;
`;

const MainContent = styled.div`
  width: 78%;
  float: right;
`;
const Title = styled.h1`
  font-weight: 600;
  font-size: 2em;
  margin: 0;
  padding: 0;
`;
const SubTitle = styled.h2`
  font-weight: 600;
  font-size: 1.2em;
  margin: 30px 0 10px 0;
  padding: 0;
`;
const ListItem = styled.li`
  color: #636161;
  margin: 0 0 10px 0;
`;
const TextBlock = styled.p`
  color: #636161;
`;

function CustomerTerms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <ContainerMain>
      <Navigation />
      <Container>
        <Nav>
          <RulesNav />
        </Nav>
        <MainContent>
          <Title>Terms of Service for Customers</Title>
          <SubTitle>Responsibility as a platform –</SubTitle>
          <TextBlock>
            We are not accountable or answerable for any act, omission,
            negligence, and/or failure some of shops, or any third-party service
            provider with respect to price and connected services. Maplun.com
            doesn't manufacture nor will it take responsibility for any product
            sold on its platform. Unless it's explicit within the sales that a
            definite product has guarantee for it, we don’t offer any assurance
            or guarantee for product.
          </TextBlock>
          <TextBlock>
            Being an internet platform, we don’t store any product and can't
            check the originality of the product and can't guarantee it unless
            it's mentioned.{" "}
          </TextBlock>
          <TextBlock>
            As a customer you're suggested to directly discuss with the
            shops/merchants to be assured of the standard, price, originality
            and specifications of the product or service.
          </TextBlock>
          <SubTitle>Return or Refund Policy</SubTitle>
          <TextBlock>
            Your rights and responsibilities as a customer, you shall order or
            book a product and connected delivery service on condition that
            you're willing to accept the product. You shall NOT CANCEL any order
            once it's confirmed unless your rejection qualify for return policy.
          </TextBlock>
          <TextBlock>
            You'll have to submit a refund or return claim to the shop/seller by
            following procedure and fulfilling claim criteria:
          </TextBlock>
          <ListItem>
            You can ONLY return product if the shop sends you different or
            spoilt product other than you ordered.{" "}
          </ListItem>
          <ListItem>
            For return and refund, you need to create a claim request to
            shop/seller within the same day of delivery. If you do not or fail
            to form a claim within the stipulated time, the shop reserves the
            right to reject your claim.
          </ListItem>
          <ListItem>
            If your claim is accepted, the shop/seller can refund you only in
            case, you made an advance payment or Cash-on-Delivery (COD) payment
            for the worth of the products.
          </ListItem>
          <ListItem>
            You can also lodge your claim to Maplun if seller fails to solve
            your issue. We may begin an investigation if so required in serious
            case. This investigation might take up to 07 calendar days to
            finish.
          </ListItem>
          <SubTitle>Promotional offers, discount & rewards -</SubTitle>
          <TextBlock>
            On this platform, all text, graphics, user interfaces, visual
            interfaces, images, trademarks, logos, design and code
            (collectively, “Content”), and arrangement of such content is
            protected by the laws of land (copyright, trademark, and numerous
            laws);
          </TextBlock>
          <TextBlock>
            No content can be traced, reproduced, republished, uploaded, posted,
            publically displayed, encoded, translated, transmitted or
            distributed in any means (including “mirroring”) to the other
            laptop, mobile phone, server, web site or any medium for publication
            or distribution or storage for any purpose without previous written
            consent.
          </TextBlock>
          <SubTitle>Restriction on content of the application -</SubTitle>
          <TextBlock>
            On this platform, all text, graphics, user interfaces, visual
            interfaces, images, trademarks, logos, design and code
            (collectively, “Content”), and arrangement of such content is
            protected by the laws of land (copyright, trademark, and numerous
            laws);
          </TextBlock>
          <TextBlock>
            No content can be traced, reproduced, republished, uploaded, posted,
            publically displayed, encoded, translated, transmitted or
            distributed in any means (including “mirroring”) to the other
            laptop, mobile phone, server, web site or any medium for publication
            or distribution or storage for any purpose without previous written
            consent.
          </TextBlock>
          <SubTitle>
            Interruption of service due to mobile network or internet connection
            -
          </SubTitle>
          <TextBlock>
            We shall create all efforts to make sure, the requests for services
            in a timely manner. The service or application is subject to
            limitations, delays and different issues inherent within the use of
            the net communications together with your device capacity. If your
            device is faulty, not connected, out of date or not functioning
            properly, the company shall never be accountable for any delays,
            delivery failures, damages or loss ensuing from such issues.
          </TextBlock>
          <SubTitle>Limitation of liability -</SubTitle>
          <TextBlock>
            Maplun.com just creates another option to buy and sell product and
            associated delivery services, subject to acceptance by the customers
            and shops directly. We shall not be responsible for any event
            arising because of any cause including inconvenience of any
            communication system, data speed, sabotage, fire, flood, explosion,
            epidemic, pandemic, natural calamities, turmoil, strikes or
            industrial action of any kind, government legislation, or
            administrative acts of government;
          </TextBlock>
          <TextBlock>
            Maplun.com and its representatives, officers, employees, agents and
            vendors shall not be responsible for any loss, damage, claim,
            expense, value (including legal costs) or liability arising directly
            or indirectly from your use or non-use of service or your reliance
            upon the service.
          </TextBlock>
          <SubTitle>
            Governing law, jurisdiction and different dispute resolution -
          </SubTitle>
          <TextBlock>
            This agreement shall be ruled by law of Bangladesh. Any dispute,
            action, claim or cause of action arising out of or in reference to
            this agreement or the service shall be subject to the jurisdiction
            of the courts of the country
          </TextBlock>
          <TextBlock>
            Any dispute with respect to quality, quantity, conformance, weight,
            items, price etc of product ordered and received shall be
            communicating with the seller directly.
          </TextBlock>
          <TextBlock>
            You agree that this agreement shall be effective subject to any or
            all prevailing statutory laws of taxes, VAT, duties and other
            relevant laws of land. You conform to use your best efforts to the
            relevant laws of land.
          </TextBlock>
          <SubTitle>Acknowledgment to the Application (web & app) -</SubTitle>
          <TextBlock>
            The terms and conditions (T&Cs) as stipulated hereafter is an
            electronic record and shall represent lawfully enforceable agreement
            (Electronic Agreement) containing ‘Terms of Use’ of Maplun.com. Your
            use, access to Maplun.com within the application shall be deemed to
            be your acceptance of these T&Cs. You acknowledge and declare that
            you have read, scanned, understood, and agreed with these T&Cs.
          </TextBlock>
          <TextBlock>
            If you do not conform to these T&Cs, either whole or partly, and
            want to discontinue the Service, please don't continue or stop
            accessing to Maplun.com. You can share your thoughts at
            support@Maplun.com
          </TextBlock>
          <TextBlock>
            Please make sure that you read and understand the subsequent “Terms
            and Conditions” before you use Maplun.com Application (both web &
            app).
          </TextBlock>
        </MainContent>
      </Container>
      <Footer />
    </ContainerMain>
  );
}

export default CustomerTerms;
